export default {"src":"/_next/static/media/dbc.2951f11b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};